import type { Component } from 'vue';
import WebResults from '../components/toolRenderers/WebResults.vue';
import WorkspaceResults from '../components/toolRenderers/WorkspaceResults.vue';
import MemoryResults from '../components/toolRenderers/MemoryResults.vue';

// Tool identity -> a viewpart that parses that tool's result JSON into rich,
// clickable content in the conversation (rendered by ToolViewparts, below the
// agent's prose). A tool listed here gets a renderer; tools NOT listed fall
// through to the plain ToolFold audit row - opt-in, declared, never inferred.
//
// Keyed by the BARE tool name. ToolViewparts strips the SDK `mcp__<server>__`
// prefix before lookup, so one entry covers both the fast-lane name
// (`search_web`) and the agent/MCP name (`mcp__hq__search_web`).
//
// Each renderer takes a `tool: ToolStep` prop and reads `tool.outputFull` (the
// tool's natural result JSON - no backend wrapper). To add one: write the
// renderer and add a line here.
export const TOOL_RENDERERS: Record<string, Component> = {
  search_web:                  WebResults,
  workspace_corpus_search:     WorkspaceResults,
  workspace_memory_search:     MemoryResults,
  workspace_memory_about_user: MemoryResults,
};
